import * as yup from 'yup';
import { AnySchema } from 'yup';
import { FormFieldsConfigProps } from 'hooks';
import { messages } from 'i18n';
import { InsightsFieldsNames } from 'broker/pages/SubmissionWorkspacePage/components/NestedViews/Quote/form-methods/enums';

type InsightsFormFieldsConfig = Record<InsightsFieldsNames, FormFieldsConfigProps<InsightsFieldsNames>>;

export const insightsFormFieldsConfig: InsightsFormFieldsConfig = {
  [InsightsFieldsNames.Insights]: {
    label: messages.addQuotePage.fieldLabels.flowInsight,
    placeholder: messages.addQuotePage.fieldPlaceholders.flowInsight,
    name: InsightsFieldsNames.Insights,
    id: InsightsFieldsNames.Insights,
  },
};

export const insightsFormValidationShape: Record<InsightsFieldsNames, AnySchema> = {
  [InsightsFieldsNames.Insights]: yup.string().default(''),
};
